import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';
import {
  color,
  space,
  typography,
  layout,
  background,
  border,
  position,
  shadow,
  textStyle,
} from 'styled-system';

import { fixPropWarnings } from '../../utils/fixPropWarnings';

interface ContentProps {
  noMargin?: boolean;
  as?: string;
  size?: string;
  fontSize?: string;
  fontWeight?: string;
  lineHeight?: string;
  p?: string;
  py?: string;
  px?: string;
  pb?: string;
  m?: string;
  my?: string;
  mx?: string;
  mb?: string;
  maxWidth?: string;
  color?: string;
}

const Content = styled.p.withConfig(fixPropWarnings('noMargin'))<ContentProps>`
  font-weight: ${themeGet('fontWeights.normal')};
  margin: initial;
  & + &,
  & + ul,
  & + ol {
    margin-top: ${({ noMargin }) => (noMargin ? '0' : '1rem')};
  }
  ${color};
  ${space};
  ${typography};
  ${layout};
  ${background};
  ${border};
  ${position};
  ${shadow};
  ${textStyle};
`;

export const Default = styled(Content)`
  font-size: 16px;
  line-height: 24px;

  @media only screen and (min-width: ${themeGet('breakpoints.xl')}) {
    font-size: 18px;
    line-height: 30px;
  }
`;

export const TableContent = styled(Content)`
  font-size: 12px;
  line-height: 22px;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    font-size: 14px;
    line-height: 22px;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.xl')}) {
    font-size: 16px;
    line-height: 24px;
  }
`;

export const CardContent = styled(Content)`
  font-size: 14px;
  line-height: 22px;

  @media only screen and (min-width: ${themeGet('breakpoints.xl')}) {
    font-size: 16px;
    line-height: 24px;
  }

  &.small {
    font-size: 36px;
    line-height: 40px;
    font-weight: ${themeGet('fontWeights.bold')};

    @media only screen and (min-width: ${themeGet('breakpoints.xl')}) {
      font-size: 40px;
      line-height: 50px;
    }
  }

  &.medium {
    font-size: 26px;
    line-height: 30px;
    font-weight: ${themeGet('fontWeights.bold')};

    @media only screen and (min-width: ${themeGet('breakpoints.xl')}) {
      font-size: 30px;
      line-height: 44px;
    }
  }

  &.large {
    font-size: 14px;
    line-height: 22px;
    font-weight: ${themeGet('fontWeights.normal')};

    @media only screen and (min-width: ${themeGet('breakpoints.xl')}) {
      font-size: 16px;
      line-height: 24px;
    }
  }
`;

export const LegalContent = styled(Content)`
  line-height: 16px;
  font-size: 12px;
  font-weight: ${({ theme }) => theme.typography.mobile.body1.fontWeight};
`;

export const FAQContent = styled(Content)`
  font-size: 16px;
  line-height: 24px;
  border-bottom: 2px solid ${themeGet('colors.greys.1')};

  @media only screen and (min-width: ${themeGet('breakpoints.xl')}) {
    font-size: 18px;
    line-height: 30px;
  }
  ${color};
`;

export default Content;
